// extracted by mini-css-extract-plugin
export default {"selectBox":"AddSchedule_selectBox__zOY-9","btn":"AddSchedule_btn__NUTFG","btndel":"AddSchedule_btndel__7AGsL"};